import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    
    if (!consent) {
      // Show banner after a short delay for better UX
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    } else {
      // Initialize analytics based on stored consent
      initializeAnalytics(consent === 'accepted');
    }
  }, []);

  const initializeAnalytics = (accepted) => {
    if (typeof window !== 'undefined' && window.gtag) {
      if (accepted) {
        // Grant consent for analytics
        window.gtag('consent', 'update', {
          analytics_storage: 'granted',
          ad_storage: 'denied', // We don't use ads
        });
        
        // Re-initialize GA4 with consent
        window.gtag('config', 'G-GLWR73FCWV', {
          anonymize_ip: true,
          cookie_flags: 'SameSite=None;Secure',
        });
      } else {
        // Deny consent
        window.gtag('consent', 'update', {
          analytics_storage: 'denied',
          ad_storage: 'denied',
        });
      }
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    initializeAnalytics(true);
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    initializeAnalytics(false);
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <h3>🍪 Cookie Notice</h3>
          <p>
            We use cookies to improve your experience and analyze website traffic. 
            This helps us understand how visitors interact with our site and which vendrs are most popular.
          </p>
          <p className="cookie-consent-details">
            By clicking "Accept", you consent to the use of Google Analytics cookies. 
            We do not use cookies for advertising. You can change your preferences at any time.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button onClick={handleDecline} className="cookie-btn cookie-btn-decline">
            Decline
          </button>
          <button onClick={handleAccept} className="cookie-btn cookie-btn-accept">
            Accept Cookies
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;

